<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Infra Setup</a></li>
          <li><a>Quick Registration</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Quick Registration</span>
        </div>
        <div class="Reports_form_div">
          <div class="row" *ngIf="businessEntity.businessCode">
            <div class="businessCode_info_css">
              <img src="assets/images/New_Icons/info-icon.svg" height="20" width="20" />
              <span>Your Unique code will be used to uniquely identify your business and products (Harvest) for your potential consumers</span>
            </div>
          </div>
          <form class="form-horizontal" id="myForm" role="form" [formGroup]="registerForm">
            <div class="reports-form-container">
              <!--Business Type Field-->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Business Type</mat-label>
                <mat-select id="businesstype" formControlName="businessType" [(ngModel)]="businessType.name">
                  <mat-option value="undefined" disabled>Select Business Type</mat-option>
                  <mat-option *ngFor="let bt of businessTypes" [value]="bt.name">{{ bt.name }}</mat-option>
                </mat-select>
                <mat-hint *ngIf="f.businessType.invalid">
                  <i>Select business type</i>
                </mat-hint>
                <mat-hint *ngIf="f.businessType.valid">
                  <i>Business type {{ businessType.name }} selected</i>
                </mat-hint>
                <mat-error *ngIf="(submitted || f.businessType.touched || f.businessType.dirty) && f.businessType.hasError('required')">
                  Required.
                </mat-error>
              </mat-form-field>
              <!--Business Name Field-->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Business Name</mat-label>
                <input matInput formControlName="businessName" autocomplete="off" [(ngModel)]="businessEntity.businessName" (input)="onBusinessChange()" (keypress)="getBusinessCode()" />
                <mat-error *ngIf="submitted || f.businessName.touched || f.businessName.dirty">
                  <ng-container *ngIf="f.businessName.hasError('required')">Required.</ng-container>
                  <ng-container *ngIf="f.businessName.hasError('minlength')">Minimum 5 characters required.</ng-container>
                  <ng-container *ngIf="f.businessName.hasError('maxlength')">Maximum 30 characters allowed.</ng-container>
                  <ng-container *ngIf="f.businessName.hasError('pattern')">Special characters and numbers are not allowed.</ng-container>
                </mat-error>
              </mat-form-field>
              <!--Business Code Entry Field-->
              <mat-form-field appearance="outline" class="w-100 disbledCls" *ngIf="businessEntity.businessCode">
                <mat-label>Your unique Code</mat-label>
                <input matInput id="businessCode" formControlName="businessCode" autocomplete="off" readonly [(ngModel)]="businessEntity.businessCode" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Person Name</mat-label>
                <input matInput id="personname" autocomplete="off" formControlName="personName" [(ngModel)]="person.firstName" />
                <mat-error *ngIf="submitted || f.personName.touched || f.personName.dirty">
                  <ng-container *ngIf="f.personName.hasError('required')">Required.</ng-container>
                  <ng-container *ngIf="f.personName.hasError('minlength')">Minimum 3 characters required.</ng-container>
                  <ng-container *ngIf="f.personName.hasError('maxlength')">Maximum 30 characters allowed.</ng-container>
                  <ng-container *ngIf="f.personName.hasError('pattern')">Special characters and numbers are not allowed.</ng-container>
                </mat-error>
              </mat-form-field>
              <!-- ───────── COUNTRY ───────── -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Country</mat-label>
                <input matInput id="country" autocomplete="off" formControlName="countryName" [matAutocomplete]="autoCountry" (focus)="filteredCountriesList=countries" (keyup)="filterCountries()" />
                <mat-autocomplete #autoCountry="matAutocomplete" (optionSelected)="coutrySelection($event.option.value)">
                  <mat-option *ngFor="let c of filteredCountriesList" [value]="c"> {{ c.name }} </mat-option>
                </mat-autocomplete>
                <mat-hint *ngIf="f.countryName.invalid"> <i>Select country</i></mat-hint>
                <mat-hint *ngIf="f.countryName.valid"><i>Country selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.countryName.touched || f.countryName.dirty) && f.countryName.hasError('required')">
                  Required.
                </mat-error>
              </mat-form-field>

              <!-- ───────── STATE ───────── -->
              <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: stateVillageDisabled }">
                <mat-label>State</mat-label>
                <input matInput id="state" autocomplete="off" formControlName="stateName" [matAutocomplete]="autoState" [disabled]="stateVillageDisabled" (focus)="filteredStatesList=states" (keyup)="filterStates()" />

                <mat-autocomplete #autoState="matAutocomplete" (optionSelected)="stateSelection($event.option.value)">
                  <mat-option *ngFor="let s of filteredStatesList" [value]="s">
                    {{ s.name }}
                  </mat-option>
                </mat-autocomplete>

                <mat-hint *ngIf="f.stateName.invalid">
                  <i>Select state</i>
                </mat-hint>
                <mat-hint *ngIf="f.stateName.valid">
                  <i>State selected</i>
                </mat-hint>

                <mat-error *ngIf="(submitted || f.stateName.touched || f.stateName.dirty) && f.stateName.hasError('required')">
                  Required.
                </mat-error>
              </mat-form-field>

              <!-- ───────── VILLAGE ───────── -->
              <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: stateVillageDisabled }">
                  <mat-label>Village Selection</mat-label>

                  <input
                    matInput
                    id="village"
                    autocomplete="off"
                    formControlName="villageName"
                    [matAutocomplete]="autoVillage"
                    [disabled]="stateVillageDisabled || isLoadingVillages"
                    (keyup)="filterVillages($event)"
                    (focus)="onVillageFocus()"
                    (blur)="onVillageBlur()"
                    #autoTrigger="matAutocompleteTrigger"
                  />

                  <!-- Loader while fetching API -->
                  <mat-spinner *ngIf="isLoadingVillages" diameter="20" class="absolute right-2 top-2"></mat-spinner>

                  <mat-autocomplete #autoVillage="matAutocomplete" panelClass="village-panel">
                    <!-- Error message if API fails -->
                    <mat-option *ngIf="villagesLoadError" disabled>
                      Villages fetching failed. Reselect state to retry.
                    </mat-option>

                    <!-- No data found message -->
                    <mat-option *ngIf="noDataFound" disabled>
                      No data found
                    </mat-option>

                    <!-- Virtual Scroll Container -->
                    <cdk-virtual-scroll-viewport itemSize="48" style="height: 250px;" 
                      [style.height.px]="visibleVillages.length < CHUNK_SIZE ? visibleVillages.length * 48 : 250"
                      (scrolledIndexChange)="onVillageScroll()"
                      [minBufferPx]="500"
                      [maxBufferPx]="1000">
                      <div *cdkVirtualFor="let v of visibleVillages; let i = index">
                        <mat-option [value]="v.city_town_village_name" (click)="villageSelection(v)">
                          {{ v.city_town_village_name }}
                        </mat-option>
                      </div>

                      <!-- Loader inside scroll -->
                      <div class="loader-section" *ngIf="isLoadingMore">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span>Loading more...</span>
                      </div>
                    </cdk-virtual-scroll-viewport>
                  </mat-autocomplete>

                  <mat-hint *ngIf="f.villageName.invalid"><i>Select village</i></mat-hint>
                  <mat-hint *ngIf="f.villageName.valid"><i>Village selected</i></mat-hint>

                  <mat-error *ngIf="(submitted || f.villageName.touched || f.villageName.dirty) && f.villageName.hasError('required')">
                    Required.
                  </mat-error>
              </mat-form-field>

              <!-- ───────── DIAL CODE (readonly) ───────── -->
              <mat-form-field appearance="outline" class="w-100 dialcode-farm-element">
                <mat-label>Dial</mat-label>
                <input matInput class="dialcode-field" formControlName="dialCode" readonly [(ngModel)]="businessEntity.dialingCode" />
              </mat-form-field>

              <!-- ───────── CONTACT NUMBER ───────── -->
              <mat-form-field appearance="outline" class="w-100 number-field">
                <mat-label>Contact Number</mat-label>
                <input matInput id="mobilenumber" autocomplete="off" formControlName="mobileNumber" [(ngModel)]="businessEntity.mobileNumber" />

                <mat-error *ngIf="submitted || f.mobileNumber.touched || f.mobileNumber.dirty">
                  <ng-container *ngIf="f.mobileNumber.hasError('required')">Required.</ng-container>
                  <ng-container *ngIf="f.mobileNumber.hasError('pattern')">Invalid mobile number.</ng-container>
                </mat-error>
              </mat-form-field>

              <!-- ───────── EMAIL ───────── -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Email Id</mat-label>
                <input matInput id="email" autocomplete="off" formControlName="email" [(ngModel)]="businessEntity.email" />

                <mat-error *ngIf="submitted || f.email.touched || f.email.dirty">
                  <ng-container *ngIf="f.email.hasError('pattern')">Enter valid email.</ng-container>
                </mat-error>
              </mat-form-field>
            </div>
          </form>
          <div class="row">
            <div class="buttons-div">
              <div class="transactions-button-container" (click)="Registration()">
                <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
                  <span class="icon"><img src="../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">Submit</span>
                </button>
              </div>
              <div class="transactions-button-container">
                <button class="transaction-close-button" (click)="cancel()">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/cross-icon.svg"></span>
                  <span class="text">Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
